import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, EntityView, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../../Cadenas/Cadenas";
import { catCanales } from "../../Categorias y Estados/catCanales";
import { Tiendas } from "../../Tiendas/Tiendas";
import { Personal } from "../Personal";
import { PersonalGestionFilters } from "../PersonalGestionFilters/PersonalGestionFilters";
import { PersonalTiendasFilters } from "../PersonalTiendasFilters/PersonalTiendasFilters";
import { PersonalTiendasFiltersPorPersonal } from "../PersonalTiendasFiltersPorPersonal/PersonalTiendasFiltersPorPersonal";
import { PersonalTiendasGestionFilters } from "../PersonalTiendasGestionFilters/PersonalTiendasGestionFilters";
import { ACTAgregarTienda } from "./ACTAgregarTienda";
import { ACTAsignarPersonal } from "./ACTAsignarPersonal";
import { ACTEliminarTienda } from "./ACTEliminarTienda";
import { ACTGestionarTiendas } from "./ACTGestionarTiendas";
import { ACTReasignarTienda } from "./ACTReasignarTienda";
import { ACTVerTienda } from "./ACTVerTienda";
import { GestionTiendasPersonalViewInfoWindowRenderer } from "./GestionTiendasPersonalViewInfoWindowRenderer";
import { GestionTiendasPersonalViewMarkerRenderer } from "./GestionTiendasPersonalViewMarkerRenderer";
import { StandardViewColumnsOverrides } from "./StandardViewColumnsOverrides";
import { StandardViewInfoWindowRenderer } from "./StandardViewInfoWindowRenderer";
import { StandardViewMarkerRenderer } from "./StandardViewMarkerRenderer";

const columns = () =>
(
    {
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.PK, prompt: 'Personal Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PK, prompt: 'Tienda Id' }),
        c_cadena_id: new EntityColumn<string>({ name: 'c_cadena_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Cadena Id' }),
        vc_canales: new EntityColumn<string[]>({ name: 'vc_canales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Canales', isArray: true }),
        vc_domicilio_completo: new EntityColumn<string>({ name: 'vc_domicilio_completo', type: 'char', length: 20, flags: c.FK, prompt: 'Domicilio Completo' }),
        f_latitud: new EntityColumn<number>({ name: 'f_latitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Latitud' }),
        f_longitud: new EntityColumn<number>({ name: 'f_longitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Longitud' }),
        vc_personales: new EntityColumn<string[]>({ name: 'vc_personales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Supervisión', isArray: true }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        plti_brwStandard: {
            name: 'plti_brwStandard', keyMappings: { c_tienda_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalTiendasFilters(client, parentKeys),
            gridColumnsOverrides: StandardViewColumnsOverrides,
            mapMarkerRenderer: StandardViewMarkerRenderer,
            mapInfoWindowRenderer: StandardViewInfoWindowRenderer
        } as EntityView,
        plti_brwPorPersonal: {
            name: 'plti_brwPorPersonal', keyMappings: { c_tienda_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalTiendasFiltersPorPersonal(client, parentKeys),
            gridColumnsOverrides: StandardViewColumnsOverrides,
            mapMarkerRenderer: StandardViewMarkerRenderer,
            mapInfoWindowRenderer: StandardViewInfoWindowRenderer
        } as EntityView,
        plti_brwGestionTiendas: {
            name: 'plti_brwGestionTiendas', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalGestionFilters(client, parentKeys),
        },
        plti_brwGestionTiendasPersonal: {
            name: 'plti_brwGestionTiendasPersonal', keyMappings: { c_personal_id: 0, c_tienda_id: 1 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalTiendasGestionFilters(client, parentKeys),
            mapMarkerRenderer: GestionTiendasPersonalViewMarkerRenderer,
            mapInfoWindowRenderer: GestionTiendasPersonalViewInfoWindowRenderer
        },
        plti_brwGestionTiendasPersonalAgregar: {
            name: 'plti_brwGestionTiendasPersonalAgregar', keyMappings: { c_tienda_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new PersonalTiendasGestionFilters(client, parentKeys),
            mapMarkerRenderer: GestionTiendasPersonalViewMarkerRenderer
        },
    }
)

const lookups = () =>
(
    {
        'Personal': {
            name: 'Personal',
            view: 'perl_brwJefes',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },

        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catCanales(client, parentKeys)
        }
    }
)

const clientActions = () =>
(
    {
        ACTSeleccionarTiendas: ACTAsignarPersonal,
        ACTVerTienda: ACTVerTienda,
        ACTGestionarTiendas: ACTGestionarTiendas,
        ACTAgregarTienda: ACTAgregarTienda,
        ACTEliminarTienda: ACTEliminarTienda,
        ACTReasignarTienda: ACTReasignarTienda
    }
)
export class PersonalTiendasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();

    constructor() {
        super('PersonalTiendas');
    }
}